import React from "react";
import { Button, Grid } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";

export const ConfirmButtons = ({ accept, cancel, acceptTitle, disabled }) => {
  return (
    <Grid
      style={{ marginTop: 40 }}
      container
      direction="row"
      justify="center"
      alignItems="center"
    >
      <Grid item>
        <Button
          color="primary"
          style={{ marginRight: 50, width: 150 }}
          onClick={() => cancel()}
        >
          Cancelar
        </Button>
      </Grid>
      <Grid item>
        <Button
          disabled={disabled}
          variant="contained"
          color="primary"
          type="submit"
          endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
          onClick={() => accept()}
        >
          {acceptTitle || "Guardar"}
        </Button>
      </Grid>
    </Grid>
  );
};
